// @flow
import React from 'react'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import * as cf from 'cf'
import gridStore from 'stores/grid'

import alertStore from 'stores/alert'

type State = {
  from: string,
  to: string
}

export default class CloneGrid extends React.Component<{}, State> {

    state = {
        from: '',
        to: ''
    }

    locations = [
      'MOBILE_M',
      'MOBILE_L',
      'TABLET',
      'LAPTOP',
      'LAPTOP_L',
      'LAPTOP_XL',
    ]
    
    handleButtonClick = () => {
        if(!this.state.from || !this.state.to) return
        alertStore.set({
            title: `Kopiere Grid von "${this.state.from}" nach "${this.state.to}"`,
            body: `Du bist kurz davor den Inhalt von dem Grid "${this.state.from}" nach "${this.state.to}" zu kopieren.
            Damit werden alle Inhalte in diesem Grid überschrieben. Das alte Grid wird damit gelöscht. 
            Bitte nur ausführen, wenn du weißt was du tust ;)`,
            onOk: () => gridStore[this.state.to].updateFormattedGrid(gridStore[this.state.from].formattedGrid)
        })
    }

    render(){
        return (
            <Wrapper>
                <Dropdown 
                    placeholder='from'
                    values={this.locations}
                    value={this.state.from}
                    onChange={from => this.setState({from})}
                />
                <Dropdown 
                    placeholder='to'
                    values={this.locations}
                    value={this.state.to}
                    onChange={to => this.setState({to})}
                />
                <Button className="Button" onClick={this.handleButtonClick}>Copy</Button>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    display: flex;
    > .Dropdown { flex: 1; margin-right: 5px; }
    > .Button { flex: 1; }
`

const Button = styled.div`
    background: rgb(0, 150, 136);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/config/CloneGrid.js